/**
 * @generated SignedSource<<70e6a9b6294615e018b08ddf5e08df6a>>
 * @relayHash 516e6c99eaf113013654fcd3aebcb5e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678

import type { ConcreteRequest } from 'relay-runtime';
export type NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery$variables = Record<PropertyKey, never>;
export type NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery = {
  response: NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery$data;
  variables: NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "516e6c99eaf113013654fcd3aebcb5e2",
    "id": "e4ababbba22834a265c1eaaf1331c05b72e39c2b8563b507658ba567e9e28678",
    "metadata": {},
    "name": "NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery",
    "operationKind": "query",
    "text": "query NthUserHomeOnboardingTakeoverGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "5891a9fd74f90ddceb310fcec3a040ef";

export default node;
